<template>
  <div class="materi-page">
    <div class="container-fluid mt-1">
      <div class="row">
        <div class="col-xl-8 mb-5 mb-xl-0">
          <card header-classes="bg-transparent" body-classes="bg-transparent p-0">
            <div slot="header" class="row align-items-center">
              <div class="col-lg-6">
                <h6 class="text-uppercase ls-1 mb-1">Kumpulan Materi</h6>
              </div>
              <div class="col-lg-6 text-lg-right" v-if="modul.is_admin">
                <b-button variant="primary" size="sm" @click="showMateriFormModal(null)"><i class="fa fa-plus" aria-hidden="true"></i> Tambah Materi</b-button>
              </div>
            </div>
            <div v-if="modul.list_material && modul.list_material.length > 0" class="text-center text-muted">
              <b-table :responsive="true" :items="modul.list_material" :fields="table.fields" thead-class="d-none">
                <template #cell(name)="data">
                  <div class="row">
                    <div @click="storeUserMaterial(modul.total_duration, data.item.id)" class="col-lg-9 materi-name line-with-icon my-2" style="cursor: pointer" v-b-toggle="'collapse-modul-' + data.item.id">
                      <i class="clr-red fa fa-book" aria-hidden="true"></i>
                      <div class="ml-1">
                        <b>
                          {{ data.item.name }}
                        </b>
                      </div>
                      <div class="ml-1 text-muted" style="font-size: 12px">
                        {{ data.item.created }}
                      </div>
                    </div>
                    <!-- <div v-if="modul.is_admin" class="col-lg-3 text-lg-right my-2">
                                            <b-badge v-if="data.item.is_publish == '1'" variant="info">Published</b-badge>
                                            <b-badge v-else variant="info">Draft</b-badge>
                                        </div> -->
                    <b-collapse :id="'collapse-modul-' + data.item.id">
                      <b-card>
                        <div class="p-1">
                          <a v-if="data.item.file_type == 'pdf' && data.item.file_path != '-'" :href="data.item.download_link" target="_blank" class="icon-clicked p-1">
                            <b-button variant="info" size="sm"><i class="fa fa-download" aria-hidden="true"></i> Download</b-button>
                          </a>
                        </div>
                        <div v-if="data.item.is_file == 1">
                          <div v-if="data.item.file_type == 'video'" class="card-footer">
                            <b-button variant="primary" size="sm" @click="openVideo(data.item.file_path, data.item.name)"><i class="fa fa-video" aria-hidden="true"></i> Play</b-button>
                          </div>
                          <div v-else style="text-align: center">
                            <iframe :src="data.item.view_link" width="100%" height="500"></iframe>
                          </div>
                        </div>
                        <div v-else>
                          <p v-html="data.item.description"></p>
                        </div>
                      </b-card>
                    </b-collapse>
                  </div>
                  <hr />
                  <div class="materi-comment d-flex text-muted">
                    <div class="mx-1" style="cursor: pointer" v-b-toggle="'collapse-' + data.item.id">{{ data.item.comments.length }} Komentar</div>
                    <div class="line-with-icon mx-1 mb-0" style="cursor: pointer" @click="focusInput('input-comment-' + data.item.id)">
                      <i class="fa fa-comment" aria-hidden="true" style="line-height: 1"></i>
                      <div>Komentari</div>
                    </div>
                  </div>
                  <hr class="mb-0" />
                  <b-collapse v-if="data.item.comments && data.item.comments.length > 0" :id="'collapse-' + data.item.id">
                    <b-card style="border-radius: unset">
                      <div :class="'item-comment-' + index" v-for="(comment, index) in data.item.comments" :key="'comment-row-' + index">
                        <div class="d-flex my-3" style="border-bottom: 1px black" :class="index + 1 == data.item.comments.length ? 'mb-0' : ''">
                          <div class="mx-1">
                            <img :src="comment.image_path" alt="" style="max-width: 50px; max-height: 50px" />
                          </div>
                          <div class="mx-1" style="width: 100%">
                            <div class="comment-user">
                              <div class="name">
                                {{ comment.full_name }}
                              </div>
                              <div class="created-time">
                                <sup>{{ comment.created }}</sup>
                              </div>
                              <div class="desc">
                                {{ comment.comment }}
                              </div>
                            </div>
                            <hr class="my-1" />
                            <div class="comment-comment-button d-flex text-muted">
                              <div class="mx-1" style="cursor: pointer" v-b-toggle="'collapse-balasan-' + comment.id">{{ comment.reply.length }} Balasan</div>
                              <div class="line-with-icon mx-1 mb-0" style="cursor: pointer" @click="focusInput('input-balasan-' + comment.id, 0)">
                                <i class="fa fa-comment" aria-hidden="true" style="line-height: 1"></i>
                                <div>Balas</div>
                              </div>
                            </div>
                            <b-collapse v-if="comment.reply && comment.reply.length > 0" :id="'collapse-balasan-' + comment.id">
                              <b-card style="border-radius: unset">
                                <div :class="'item-balasan-' + index2" v-for="(balas, index2) in comment.reply" :key="'comment-balasan-row-' + index2">
                                  <div class="d-flex my-3" style="border-bottom: 1px black" :class="index2 + 1 == comment.reply.length ? 'mb-0' : ''">
                                    <div class="mx-1">
                                      <img :src="balas.image_path" alt="" style="max-width: 50px; max-height: 50px" />
                                    </div>
                                    <div class="mx-1" style="width: 100%">
                                      <div class="balas-user">
                                        <div class="name">
                                          {{ balas.full_name }}
                                        </div>
                                        <div class="created-time">
                                          <sup>{{ balas.created }}</sup>
                                        </div>
                                        <div class="desc">
                                          {{ balas.comment }}
                                        </div>
                                      </div>
                                      <hr class="my-1" />
                                    </div>
                                  </div>
                                  <hr class="m-0" v-show="index2 + 1 != comment.reply.length" />
                                </div>
                              </b-card>
                            </b-collapse>
                            <b-form @submit="onSubmitReply(data.item, comment)">
                              <b-form-input
                                :id="'input-balasan-' + comment.id"
                                :ref="'input-balasan-' + comment.id"
                                placeholder="Tuliskan balasan disini"
                                v-model="comment.comment_reply"
                                style="background: transparent; border-radius: unset; font-size: 13px"
                                autocomplete="off"
                              ></b-form-input>
                            </b-form>
                          </div>
                        </div>
                        <hr class="m-0" v-show="index + 1 != data.item.comments.length" />
                      </div>
                    </b-card>
                  </b-collapse>
                  <b-form @submit="onSubmitComment(data.item)">
                    <b-form-input
                      :id="'input-comment-' + data.item.id"
                      :ref="'input-comment-' + data.item.id"
                      placeholder="Tuliskan komentar disini"
                      v-model="data.item.comment"
                      style="background: transparent; border-radius: unset; font-size: 13px"
                      autocomplete="off"
                    ></b-form-input>
                  </b-form>
                </template>
                <template #cell(actions)="data" v-if="modul.is_admin">
                  <div class="my-2">
                    <a href="javascript:void(0)" class="icon-clicked p-1" @click="showMateriFormModal(data.item)"><i class="fa fa-edit" aria-hidden="true"></i></a>
                    <a href="javascript:void(0)" class="icon-clicked p-1" @click="confirmDeleteMateri(data.item.id)"><i class="fa fa-trash" aria-hidden="true"></i></a>
                  </div>
                </template>
              </b-table>
            </div>
            <div v-else class="p-2 text-center text-muted">Saat ini belum ada Materi</div>
          </card>
        </div>
        <div class="col-xl-4">
          <div class="card">
            <div class="card-header row align-items-center bg-transparent">
              <div class="d-flex justify-content-between" style="align-items: center">
                <div class="col">
                  <h6 class="text-uppercase ls-1 mb-1">Info</h6>
                </div>
                <div>
                  <b-dropdown id="dropdown-1" right text="Kembali" size="sm" class="m-md-2">
                    <b-dropdown-item
                      ><router-link :to="{ name: 'subject-detail', params: { subjectId: modul.subjects_id } }" class="icon-clicked p-1"><i class="clr-red fa fa-arrow-left" aria-hidden="true"></i> Halaman Modul</router-link></b-dropdown-item
                    >
                  </b-dropdown>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="identity px-2">
                <p class="line-with-icon"><i class="clr-red fa fa-user" aria-hidden="true"></i>{{ modul.user_name }}</p>
                <p class="line-with-icon"><i class="clr-red fa fa-user" aria-hidden="true"></i>{{ modul.user_status }}</p>
                <p class="line-with-icon"><i class="clr-red fa fa-book" aria-hidden="true"></i>{{ modul.subject_name }}</p>
                <p class="line-with-icon"><i class="clr-red fa fa-folder-open" aria-hidden="true"></i>{{ modul.name }}</p>
              </div>
            </div>
            <div class="card-footer">
              <div class="card">
                <div class="card-body text-center">
                  <h6>{{ modul.total_material }}</h6>
                  <h6>Materi</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="materi-form-modal" class="materi-form-modal" size="lg" :title="setTitle" @show="resetMateriForm" @hidden="resetMateriForm" hide-footer no-close-on-backdrop>
      <materi-form :modulId="modul.id" :materiId="materiId" :materiDetail="materiDetail"></materi-form>
    </b-modal>
    <b-modal ref="open-video" class="open-video" size="lg" :title="fileTitle" hide-footer no-close-on-backdrop>
      <div>
        <video-embed :src="filePath"></video-embed>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/eventBus.js";
import MateriForm from "../../../components/Main/Materi/MateriForm";
export default {
  components: {
    MateriForm,
  },
  data() {
    return {
      setTitle: "",
      materiId: null,
      filePath: null,
      startTime: null,
      materialId: null,
      currentDuration: 0,
      endTime: null,
      fileTitle: "",
      taId: this.$route.params.taId,
      materiDetail: {},
      table: {
        fields: [
          { key: "name", label: "Name", class: "data-column custom text-left" },
          { key: "actions", label: "Actions", class: "action-column custom" },
        ],
      },
      form_comment: {
        modul_id: null,
        parent_id: "X0w1O1km97SKnZxxqBZwfR",
        comment: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      modul: "getModulDetail",
    }),
  },
  watch: {
    modul(val) {
      if (!val.is_admin) {
        this.table.fields.splice(1, 1);
      }
    },
  },
  methods: {
    async submitDuration() {
      if (this.startTime != null) {
        this.endTime = Date.now();
        const duration = (this.endTime - this.startTime) / 1000;
        let materialId = this.materialId;
        let totalDuration = duration + Number(this.currentDuration);

        if (totalDuration < 300 && this.user.type == "murid") {
          this.$swal.fire(
            "Perhatian !",
            "Waktu belajar Anda kurang dari 5 menit. Anda sudah mempelajari materi selamat " +
              this.formatDuration(totalDuration) +
              ", silahkan lanjutkan pelajari materi ini atau materi yang lain lain dalam modul ini untuk mendapatkan milai.",
            "warning"
          );
        } else {
          await this.$store
            .dispatch("storeUserMaterial", { materialId })
            .then(() => {})
            .catch((err) => {
              this.$swal.fire("Failed", err.response.data.message, "error");
            });
        }
        await this.$store
          .dispatch("storeUserMaterialDuration", { materialId, duration })
          .then(() => {})
          .catch((err) => {
            this.$swal.fire("Failed", err.response.data.message, "error");
          });
      }
    },
    formatDuration(seconds) {
      const h = Math.floor(seconds / 3600);
      const m = Math.floor((seconds % 3600) / 60);
      const s = Math.floor(seconds % 60);

      return [h > 0 ? h + " jam" : "", m > 0 ? m + " menit" : "", s > 0 ? s + " detik" : ""].filter(Boolean).join(" ");
    },
    showMateriFormModal(param) {
      if (param) {
        this.materiId = param.id;
        this.materiDetail = param;
        this.setTitle = "Edit Materi";
      } else {
        this.materiDetail = {};
        this.materiId = null;
        this.setTitle = "Tambah Materi";
      }
      this.$refs["materi-form-modal"].show();
    },
    openVideo(path, title) {
      this.filePath = path;
      this.fileTitle = title;
      this.$refs["open-video"].show();
    },
    storeUser(id) {
      if (id) {
        this.getModulDetail();
      }
    },
    hideMateriFormModal() {
      this.$refs["materi-form-modal"].hide();
      this.resetMateriForm();
    },
    resetMateriForm() {
      EventBus.$emit("resetMateriForm", true);
    },
    resetComment() {
      this.form_comment.modul_id = null;
      this.form_comment.parent_id = "X0w1O1km97SKnZxxqBZwfR";
      this.form_comment.comment = null;
    },
    focusInput(val, index = null) {
      if (index == 0) {
        this.$refs[val][0].focus();
      } else {
        this.$refs[val].focus();
      }
    },
    async onSubmitComment(param) {
      if (param.comment) {
        EventBus.$emit("showLoaderOverlay", true);
        this.form_comment.modul_id = param.id;
        this.form_comment.comment = param.comment;
        let form = this.form_comment;
        await this.$store
          .dispatch("addComment", form)
          .then(() => {
            this.getModulDetail();
            param.comment = null;
            this.resetComment();
            EventBus.$emit("hideLoaderOverlay", true);
          })
          .catch((err) => {
            EventBus.$emit("hideLoaderOverlay", true);
            this.$swal.fire("Failed", err.response.data.message, "error");
          });
      }
    },
    async onSubmitReply(materi, param) {
      if (param.comment_reply) {
        EventBus.$emit("showLoaderOverlay", true);
        this.form_comment.modul_id = materi.id;
        this.form_comment.parent_id = param.id;
        this.form_comment.comment = param.comment_reply;
        let form = this.form_comment;
        await this.$store
          .dispatch("addReply", form)
          .then(() => {
            this.getModulDetail();
            param.comment_reply = null;
            this.resetComment();
            EventBus.$emit("hideLoaderOverlay", true);
          })
          .catch((err) => {
            EventBus.$emit("hideLoaderOverlay", true);
            this.$swal.fire("Failed", err.response.data.message, "error");
          });
      }
    },
    async getModulDetail() {
      let modulId = this.$route.params.modulId;
      await this.$store
        .dispatch("getModulDetail", { modulId })
        .then(() => {})
        .catch((err) => {
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
    async storeUserMaterial(totalDuration, materialId) {
      this.startTime = Date.now();
      this.materialId = materialId;
      this.currentDuration = totalDuration == null ? 0 : totalDuration;
      console.log("this.currentDuration", this.currentDuration);
    },
    async confirmDeleteMateri(materiId) {
      this.$swal
        .fire({
          title: "Apakah anda yakin?",
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ya, saya yakin",
          cancelButtonText: "Tidak",
        })
        .then((result) => {
          if (result.value) {
            this.deleteMateri(materiId);
          }
        });
    },
    async deleteMateri(id) {
      await this.$store
        .dispatch("deleteMateri", { id })
        .then((res) => {
          this.getModulDetail();
          this.$swal.fire("Success", res.message, "success");
        })
        .catch((err) => {
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
  },
  beforeDestroy() {
    this.submitDuration();
  },
  created() {
    this.setCurrentModulId(this.$route.params.modulId);
    this.getModulDetail();
    EventBus.$on("hideMateriFormModal", (val) => {
      if (val) {
        this.hideMateriFormModal();
      }
    });
  },
};
</script>
<style lang="css" scoped>
.item-comment-0 div {
  margin-top: unset !important;
}
.item-balasan-0 div {
  margin-top: unset !important;
}
.btn-primary {
  color: #fff;
  background-color: #ca062a;
  border-color: #ca062a;
}
.table-responsive {
  margin-bottom: 0;
}
.btn-primary:hover,
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:focus {
  color: #fff;
  background-color: #ca062a;
  border-color: #ca062a;
  -webkit-box-shadow: unset;
  box-shadow: unset;
}
</style>
